import { createContext } from 'react';

interface AdminPanelDrawerProviderValue {
  isFormClean: boolean;
  triggerClose: boolean;
  triggerTabChange: boolean;
  tabIndex: string;
  setIsFormClean: (value: boolean) => void;
  handleTriggerChangeTab: (
    event: React.SyntheticEvent,
    newValue: string,
  ) => void;
  handleCloseTrigger: () => void;
  handleClear: () => void;
  handleCloseConfirmationModal: () => void;
}

export const AdminPanelDrawerContext =
  createContext<AdminPanelDrawerProviderValue>({
    isFormClean: false,
    triggerClose: false,
    triggerTabChange: false,
    tabIndex: '1',
    setIsFormClean: (value: boolean) => value,
    handleTriggerChangeTab: (event: React.SyntheticEvent, newValue: string) =>
      newValue,
    handleCloseTrigger: () => undefined,
    handleClear: () => undefined,
    handleCloseConfirmationModal: () => undefined,
  });
